module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAStJREFUaEPtmT0SgjAQhZMZa29hgadQCx0KLuMJPIGXoWC0UE8hhbegZiY24PAzuiGbQIKPEkjy3n67SQhSBH7JwPULGJiaIAh4RyC9PleLhUyEFMupxbXGV6IoS5Um+/Wreb+XQtktP3onvlasRBHvovNvA/f85FXkO2LibdTS1ycwNwNdx2PTyToBHUwABpjIQMA0hS6PXDWDf9hERqv+ZARgoMIHAqiBKhVmV8S6Re5tDcBAlZrkbtRVEYPA3xOgUoD7vN5HOZuFuAKp9jBQR+DbLERFkPscBECA+CKjUgwpRKUQ87BBu7mzdUBbAfNFGDDdjTID/2nOJmBLiK1+Bp+N2hrYVj+0gdB/cAT/i8kW6rH6MTpwHUuczjgwoBMll++AgMvo6vT9BkdKuEBuE1zhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/StatisticalAnalysisManage.png
// module id = mEzK
// module chunks = 0